let $ = window.$ || window.jQuery || require('jquery');
window.$ = window.jQuery = $;

const { default: Swiper } = require('swiper/bundle');
window.Swiper = Swiper;

import CartWidget from 'theme/js/cart/cartwidget';
import CartIconWidget from 'theme/js/cart/carticonwidget';

import siteConfig from 'shared/js/siteConfig';
import initLazyLoad from 'shared/js/lazyLoad';
import { VOYADO_SCRIPT_LOADED } from 'shared/js/voyadoEventNames';

const processInclude = require('theme/js/util');

// Dependencies pre-inclusion.
require('lazysizes');
require('theme/js/components/spinner');
require('theme/js/thirdParty/bootstrap');

// Dependencies inclusion on document-ready.
const modules = () => {
    processInclude(require('theme/js/components/eventListeners'));
    processInclude(require('theme/js/components/header'));
    processInclude(require('theme/js/components/menu'));
    processInclude(require('theme/js/components/cookie'));
    processInclude(require('theme/js/components/consentTracking'));
    processInclude(require('theme/js/components/footer'));
    processInclude(require('theme/js/components/collapsibleItem'));
    processInclude(require('theme/js/components/clientSideValidation'));
    processInclude(require('theme/js/components/countrySelector'));
    processInclude(require('theme/js/components/toolTip'));

    processInclude(require('theme/js/cart/miniCart')); // SFRA/wishlist cartridges - base/components/miniCart
    processInclude(require('theme/js/components/dropdown'));
    processInclude(require('theme/js/components/tabs'));
    processInclude(require('theme/js/components/search'));
    processInclude(require('theme/js/components/fold'));
    processInclude(require('theme/js/components/withdrawalPopup'));
    processInclude(require('theme/js/components/widgets/blogcarousel'));
    processInclude(require('theme/js/components/widgets/herobanner'));
    processInclude(require('theme/js/components/messageBanner'));
    processInclude(require('theme/js/components/shippingPromise'));
    processInclude(require('theme/js/product/wishlist'));
    processInclude(require('theme/js/product/quickView'));
    processInclude(require('theme/js/loginModal'));
};

// If we have only cookieName it will return cookieName value. If searchCookie is added too, it will return value of that exact part of the cookieName value
function getCookie(cookieName, searchCookie) {
    let cookie = {};
    document.cookie.split(';').forEach(function (el) {
        let [, key, value] = el.match(/^([^=]+)=(.*)$/);
        cookie[key.trim()] = value;
    });

    if (!cookie[cookieName]) {
        return null;
    }

    if (!searchCookie) {
        return cookie[cookieName];
    }

    // extract & decode the groups value
    var groupsMatch = cookie[cookieName].match(/(?:^|&)groups=([^&]+)/);
    var groups = groupsMatch ? decodeURIComponent(groupsMatch[1]) : '';

    // find searchCookie:<digit>
    const escaped = searchCookie.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    const match = groups.match((`(?:^|,)${escaped}:(\\d)(?=,|$)`));
    var cookieValue = match ? match[1] : null; // "1" or "0" (string), or null if not found

    return cookieValue == '1' ? cookieValue : null;
}

// Dixa function
(function (w, d) {
    if (w._dixa_) return;
    // Define the stub immediately so any `_dixa_.invoke('init', ...)` calls are
    // queued and replayed once the bootstrap script is eventually loaded.
    w._dixa_ = {
        invoke: function (m, a) {
            w._dixa_.pendingCalls = w._dixa_.pendingCalls || [];
            w._dixa_.pendingCalls.push([m, a]);
        },
    };

    var dixaScriptLoaded = false;
    function loadDixaScript() {
        if (dixaScriptLoaded) return;
        dixaScriptLoaded = true;

        var s = d.createElement('script');
        s.type = 'text/javascript';
        s.setAttribute('charset', 'utf-8');
        s.async = true;
        s.src = 'https://messenger.dixa.io/bootstrap.js';
        var before = d.getElementsByTagName('script')[0];
        before.parentNode.insertBefore(s, before);
    }

    // Defer loading until 1 second after the first user interaction instead of
    // on initial page load, to avoid blocking initial rendering/performance.
    var interactionEvents = ['scroll', 'click', 'touchstart'];
    function onFirstInteraction() {
        interactionEvents.forEach(function (evt) {
            w.removeEventListener(evt, onFirstInteraction);
        });
        w.setTimeout(loadDixaScript, 1000);
    }

    interactionEvents.forEach(function (evt) {
        w.addEventListener(evt, onFirstInteraction, { passive: true });
    });
}(window, document));

$(document).on('cookie:update', function () {
    // Wait for the cookie to be set
    setTimeout(() => {
        // C0003 - oneTrust functional cookies
        var acceptedCookies = getCookie('set_functional_cookies') || getCookie('OptanonConsent', 'C0003');

        if (acceptedCookies && window.SitePreferences) {
            // Dixa script
            var enableDixaWidgetLocal = window.SitePreferences.ENABLE_DIXA_WIDGET_LOCAL;

            if (enableDixaWidgetLocal) {
                var dixaMessengerTokenObjLocal = window.SitePreferences.DIXA_MESSENGER_TOKEN_OBJ_LOCAL;
                var language = window.SitePreferences.LANGUAGE;

                _dixa_.invoke('init', { // <- init is called here
                    messengerToken: dixaMessengerTokenObjLocal,
                    position: 'bottomRight',
                    showWidgetCloseButton: true,
                    language: language,
                });
            }

            // Voyado script
            var voyadoIsActive = window.SitePreferences.VOYADO_IS_ACTIVE;

            if (voyadoIsActive) {
                var voyadoScript = window.SitePreferences.VOYADO_SCRIPT;
                var voyadoTenant = window.SitePreferences.VOYADO_TENANT;

                (function (i, s, o, g, r, a, m) {
                    i.VoyadoAnalyticsObject = r;
                    i[r] = i[r] || function () {
                        (i[r].q = i[r].q || []).push(arguments);
                    };
                    i[r].l = 1 * new Date();
                    a = s.createElement(o);
                    m = s.getElementsByTagName(o)[0];
                    a.async = 1;
                    a.src = g;
                    m.parentNode.insertBefore(a, m);
                }(window, document, 'script', voyadoScript, 'va'));

                va('setTenant', voyadoTenant);

                document.dispatchEvent(
                    new CustomEvent(VOYADO_SCRIPT_LOADED)
                );
            }
        }
    }, 500);
});

$(document).on('visibilitychange', function () {
    var helper = require('./helper');
    helper.refreshSession();
});

// On document ready event trigger.
$(document).ready(() => {
    // #cartwidget is in the page body; main.js loads in <head>, so init must wait for DOM.
    CartIconWidget.init();
    CartWidget.registerCallback('cartwidget:pre-render', function () {
        CartIconWidget.render();
    });
    CartWidget.init('storefront').render();

    let executedFlag = false;
    const loadModules = () => {
        if (!executedFlag) {
            executedFlag = true;
            modules();
        }
    };
    if (siteConfig.isSite('SN')) {
        const WebFont = require('webfontloader');
        const WebFontConfig = {
            custom: {
                families: ['bodystore-icons'],
                urls: [window.staticURL + 'css/fonts.css']
            },
            active: () => loadModules()
        };

        if (WebFont && typeof WebFont.load === 'function') {
            WebFont.load(WebFontConfig);
        } else {
            loadModules();
        }
    } else {
        loadModules();
    }

    if ($('.footer').attr('data-symplify-enabled') === 'true') {
        setTimeout(() => {
            // Call Symplify endpoint to extent Symplify cookie's expiration date
            $.ajax({
                url: $('.footer').attr('data-symplify-url'),
                method: 'POST'
            });
        }, '500');
    }

    $(document).trigger('cookie:update');

    initLazyLoad();

    if ($('.header-notification').length) {
        const loginPopupDelay = window.SitePreferences && window.SitePreferences.LOGIN_POPUP_DELAY ? window.SitePreferences.LOGIN_POPUP_DELAY + 's' : '0s';
        $('.header-notification, .notification-popup-arrow-container').css('animation-delay', loginPopupDelay);
    }

    if ($('.swiper-level-info').length > 0) {
        let mainSwiper;
        let subSwiper;
        let bonusLevelName = $('[data-bonus-level]');
        let bonusLevelIndex = $('[data-bonus-level-index]')[0].dataset.bonusLevelIndex;

        mainSwiper = new Swiper('.swiper-level-info', {
            direction: 'horizontal',
            loop: false,
            initialSlide: bonusLevelIndex,
            grabCursor: true,
            autoHeight: false,

            pagination: {
                el: '.swiper-pagination-normal',
                clickable: true,
            },
        });
        subSwiper = new Swiper('.swiper-level-info', {
            initialSlide: bonusLevelIndex,

            pagination: {
                el: '.swiper-pagination-level',
                clickable: true,
                renderBullet: function (index, className) {
                    return '<span class="tab__link ' + className + '">' + bonusLevelName[index].dataset.bonusLevel + '</span>';
                },
            },
        });
        mainSwiper.controller.control = subSwiper;
        subSwiper.controller.control = mainSwiper;
    }

    // Tryggehandel script
    function loadScript(src, { timeout = 1500, attrs = {} } = {}) {
        return new Promise((resolve, reject) => {
            const s = document.createElement('script');
            s.src = src;
            Object.entries(attrs).forEach(([k, v]) => s.setAttribute(k, v));
            let done = false;

            const timer = setTimeout(() => {
                if (done) return;
                done = true;
                s.remove();
                reject(new Error(`Script load timeout: ${src}`));
            }, timeout);

            s.onload = () => { if (done) return; done = true; clearTimeout(timer); resolve(); };
            s.onerror = (e) => { if (done) return; done = true; clearTimeout(timer); s.remove(); reject(e); };

            document.head.appendChild(s);
        });
    }

    // Example usage: delay to idle (or next tick fallback)
    const deferLoad = () =>
        (window.requestIdleCallback ? requestIdleCallback(() => initVendor(), { timeout: 1500 }) : setTimeout(initVendor, 0));

    async function initVendor() {
        try {
            await loadScript('https://cert.tryggehandel.net/js/script.js?id=d47d2b29-3bd8-4fc7-b5be-cb15f9abbd2a', {
                timeout: 1500,
                defer: true
            });
        } catch (err) {
            console.warn('Tryggehandel failed or was too slow; continuing without it.', err);
        }
    }

    if (window.SitePreferences && window.SitePreferences.TRYGGEHANDEL_SCRIPT) {
        deferLoad();
    }
});
